/**
 * The sprite library at runtime is game-sprites, games-media's shared runtime (vendored as
 * vendor/game-sprites-<version>.tgz, like fleet-kit): the art manifest names the baked sets (a
 * frames.json and PNG atlases per tier on the media host); it loads them, keeps one atlas copy per
 * robe colour, and draws a figure's current clip frame at its feet, flipped for the mirrored
 * directions, tinted through a scratch canvas for statuses and the hit flash. Each figure's clip
 * runs on its own clock, so a one-shot such as a cast plays from the moment the state began and
 * holds its last frame. Until a set has landed, and whenever one fails, `art.set()` is null and the
 * vector drawing in entities.ts / enemies.ts runs instead. Which clip a state asks for is
 * Spellweave's own rule (spriteSets.ts).
 */

import { SpriteLibrary } from 'game-sprites';

export { ART_MANIFEST_URL, SpriteSet, type DrawOpts, type Drawn, type Tint } from 'game-sprites';

/** The one library of the page. */
export const art = new SpriteLibrary();
